var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Message"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Message_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1162 2.5C15.2337 2.5 16.3087 2.94167 17.0995 3.73417C17.8912 4.525 18.3337 5.59167 18.3337 6.70833V13.2917C18.3337 15.6167 16.442 17.5 14.1162 17.5H5.88367C3.55784 17.5 1.66701 15.6167 1.66701 13.2917V6.70833C1.66701 4.38333 3.54951 2.5 5.88367 2.5H14.1162ZM15.442 7.94994L15.5087 7.88327C15.7078 7.64161 15.7078 7.29161 15.4995 7.04994C15.3837 6.92577 15.2245 6.84994 15.0587 6.83327C14.8837 6.82411 14.717 6.88327 14.5912 6.99994L10.8337 9.99994C10.3503 10.4008 9.65784 10.4008 9.16701 9.99994L5.41701 6.99994C5.15784 6.80827 4.79951 6.83327 4.58368 7.05827C4.35868 7.28327 4.33368 7.64161 4.52451 7.89161L4.63368 7.99994L8.42534 10.9583C8.89201 11.3249 9.45784 11.5249 10.0503 11.5249C10.6412 11.5249 11.217 11.3249 11.6828 10.9583L15.442 7.94994Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.35f4bedc60a63135e6b78ea5e1cf013d.svg";
export { ForwardRef as ReactComponent };